// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ba7ba7af","507":"23ba22c7"}[chunkId] + ".chunk.js";
};